<template>
    <div class="automation-webhook-details" v-animate-css="{ classes: 'fadeInDown', delay: 0, duration: 300 }">
        <section>
            <span class="title">{{ $t("automation.catchAllWebhooks") }}</span>
            <div class="url">
                <a-input :value="getWebhookURL()" disabled />
                <SupsisButton @click="copy">Copy</SupsisButton>
            </div>
        </section>
        <a-divider />
        <section>
            <span class="title">{{ $t("automation.webhookDataExPreview") }}</span>

            <vue-json-pretty :data="getWebhookData()" />
        </section>
    </div>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import { BlockStyles } from "../../../BlockConfiguration";
import BlockIconPreview from "../common/BlockIconPreview";
import RRuleGenerator from "../../../../Integrations/Ticimax/detail/automation/RRuleGenerator.vue";
import SupsisButton from "../../../../Settings/components/SupsisButton.vue";
import { AUTOMATION_API } from "../../../../../../api/automation";
import { copyText2Clipboard } from "../../../../../../utils/utils";
import _ from "lodash";

import VueJsonPretty from "vue-json-pretty";
import "vue-json-pretty/lib/styles.css";
import CONFIG from "../../../../../../config/config";

const log = log2("AutomationWebhookDetails");
export default {
    name: "AutomationWebhookDetails",
    components: { VueJsonPretty, SupsisButton, RRuleGenerator, BlockIconPreview },
    props: ["automation"],
    data() {
        return {
            animationObject: { classes: "fadeInDown", delay: 0, duration: 300 },
            animationInfinite: {
                classes: "fadeIn",
                duration: 5000,
                iteration: "infinite",
            },
            copyText2Clipboard,
            cloneAutomation: _.cloneDeep(this.automation),
        };
    },
    methods: {
        getWebhookData() {
            return _.get(this.cloneAutomation, "options.webhook.example", {
                method: "POST",
                query: "",
                body: {},
                headers: {},
            });
        },
        fetchAutomation() {
            AUTOMATION_API.findAutomationById(this.automation._id).then((automation) => {
                this.cloneAutomation = _.cloneDeep(automation);
            });
        },
        copy() {
            this.copyText2Clipboard(this.getWebhookURL());
            this.$message.success($t("automation.webhookUrlCopied"));
        },
        isChanged() {
            return false;
        },
        getWebhookURL() {
            return `${CONFIG.SOCKET_URL}/webhook/automation/${this.automation.siteId}/${this.automation.options.webhook.id}`;
        },
        highlighter(code) {
            return Prism.highlight(code, Prism.languages.javascript, "javascript");
        },
        jsonFormat() {
            try {
                return this.getWebhookData();
            } catch (e) {
                return this.getWebhookData();
            }
        },
    },
    mounted() {
        this.fetchAutomation();
    },
    watch: {},
};
</script>

<style lang="scss" scoped>
.automation-webhook-details {
    box-shadow: 0 4px 20px #00000040;
    background: #ffffff;
    padding: 25px;
    border-radius: 6px;
    height: calc(100vh - 100px);
    overflow: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: 5px;

    .close-x {
        display: flex;
        flex-direction: row;
        justify-content: end;
    }

    section {
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 50px;
        background: #f7f7f7;

        .title {
            font-size: 30px;
            font-weight: 700;
            color: var(--color-text-default);
        }

        .url {
            display: flex;
            gap: 10px;
            align-items: center;

            a-input {
                width: 100%;
            }
        }

        .my-editor {
            background: #f7f7f7;
            color: #ccc;
            font-family: Fira code, Fira Mono, Consolas, Menlo, Courier, monospace;
            font-size: 14px;
            line-height: 1.5;
            padding: 5px;
            max-height: 300px;
            overflow: scroll;
        }
    }
}
</style>
